import { SET_FILTER, SET_ALL_FILTER } from '../actions/types';
import initialState from '../initialState';

export default function filter(state = initialState.filter, action) {
  switch (action.type) {
    case SET_ALL_FILTER:
      return {
        ...state,
        ...action.data,
      };
    case SET_FILTER:
      return {
        ...state,
        [action.filterType]: {
          ...state[action.filterType],
          [action.filter]: action.data,
        },
      };
    default:
      return state;
  }
}
